import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import type { InfiniteQueryOptions } from '@/types/infinite-query'
import type { LabelAndValue } from '@/types/label-and-value'
import { nextPageParamGetter } from '@/utils/next-page-param-getter'
import { parsePaginated } from '@/utils/parse-paginated'
import { idAndNameSchema, requiredString } from '@/utils/zod'

const responseSchema = z.object({
  id: requiredString(),
  name: requiredString(),
  education_level: idAndNameSchema
})

const parseResponse = (response: z.infer<typeof responseSchema>) => ({
  label: response.name,
  value: response.id,
  meta: response.education_level
})

export const getCurriculumsQueryOptions =
  (educationLevelId?: string, courseId?: string) =>
  (search?: string): InfiniteQueryOptions<LabelAndValue> => ({
    queryKey: [
      'panelSelectSectionsCurriculumsList',
      educationLevelId,
      courseId,
      search
    ],
    staleTime: 60 * 1000,
    queryFn: async ({ pageParam }) => {
      const response = await httpService.panel.panelCurriculumsList({
        search,
        page: pageParam,
        education_level_id: educationLevelId ? [educationLevelId] : undefined,
        // @ts-expect-error This will be added to the API soon
        course_id: courseId ? [courseId] : undefined,
        fetchKeys: {
          name: true,
          id: true,
          education_level: true
        }
      })

      return parsePaginated({
        schema: responseSchema,
        data: response,
        parse: parseResponse
      })
    },
    getNextPageParam: nextPageParamGetter,
    initialPageParam: 1
  })
